var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 1.25h11.5v13.5h-4v4H2.25V5.25h4zm0 5.5h-2.5v10.5h8.5v-2.5h-6zm1.5-4v10.5h8.5V2.75z",
    clipRule: "evenodd"
  })));
};
export { SvgCopy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjI1IDEuMjVIMTcuNzVWMTQuNzVIMTMuNzVWMTguNzVIMi4yNVY1LjI1SDYuMjVWMS4yNVpNNi4yNSA2Ljc1SDMuNzVWMTcuMjVIMTIuMjVWMTQuNzVINi4yNVY2Ljc1Wk03Ljc1IDIuNzVWMTMuMjVIMTYuMjVWMi43NUg3Ljc1WiIgLz4KPC9zdmc+Cg==";